<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)"
                srcset="assets/img/school-desktop-banners/arni-school-of-basic-sciences-and-biotechnology.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/arni-school-of-basic-sciences-and-biotechnology.webp">
        <img
            src="assets/img/mobile-banners-schools/arni-school-of-basic-sciences-and-biotechnology.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div class="md:flex flex-wrap hidden space-x-4 p-4 mb-4 border-2 border-gray-200 rounded-full justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400 active-tab ">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Specialization</a>
            <a href="#hoi-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Head of Institute's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">What's
                Happening</a>
            <a href="#expert-faculty" class="tab-link text-gray-500 font-medium hover:text-blue-40 xl:border-0 lg:border-b0 hover:border-blue-400">Expert Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 xl:border-0 lg:border-b hover:border-blue-400">Recruiters</a>
        </div>

        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Basic Sciences & Biotechnology</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">ARNI School of Basic Sciences and Bio-Technology of providing an
                interdisciplinary approach, exposure to different disciplines in science including Chemistry,
                Bio-Chemistry, Physics, Mathematics, Life Sciences, and Environmental Sciences. The School offers
                Undergraduate, Postgraduate and Research Programs in Physics, Chemistry, Mathematics, Biotechnology, and
                more— are designed to meet the requirement of the latest technological developments.
                The Arni School of Basic Sciences and Bio-technology is unique from other institutions of Higher
                learning as it is committed to imparting knowledge in pure and applied sciences, which not only forms
                the foundation for further academic pursuits in science and technology but also acts as the foundation
                for students to pursue a career in multi facet directions.</p>
            <p class="text-gray-500 font-semibold text-lg my-2">Empowering Tomorrow’s Scientists</p>
            <p class="text-gray-500 text-justify">The Arni School of Basic Sciences and Bio-technology task is to
                prepare a new generation of scientific thinkers ready to address real-world challenges through
                innovation and critical thinking. Programs are integrating theoretical learning with hands-on
                experience, ensuring a solid foundation in core Sciences. Through interactive labs, guest lectures,
                fieldwork, and project-based learning, students apply their knowledge to solve practical problems in
                healthcare, agriculture, and environmental science.
            </p>
            <p class="text-gray-500 font-semibold text-lg mt-2">Real-World Learning, Real Impact</p>
            <p class="text-gray-500 text-justify mb-2">The Arni School of Basic Sciences and Bio-technology, education
                goes beyond textbooks. We emphasize experiential learning—offering opportunities for students to:
            </p>
            <ul class="list-disc text-gray-500 px-5">
                <li>Engage in advanced lab work in Microbiology, Molecular Biology, Cell Culture, and Organic/Inorganic
                    Chemistry.
                </li>
                <li>Explore interdisciplinary techniques in genetic engineering, bioinformatics, and bioprocessing.</li>
                <li>Tackle pressing global issues with a blend of ethical reasoning, practical skills, and critical
                    analysis.
                </li>
                <li>Participate in national-level science fairs, conferences, and innovation challenges.</li>
            </ul>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> To be a center of excellence in basic
                science and biotechnology, inspiring discoveries and sustainable innovations that address global
                challenges.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> To empower future researchers and
                scientists with the tools, technologies, and mindset needed to solve complex problems in healthcare,
                agriculture, and the environment.
            </p>
            <p class="text-gray-500 font-semibold text-lg mt-2">Programs We Offer</p>
            <p class="text-gray-500 text-justify mb-2">ARNI University offers a comprehensive range of academic programs
                at the undergraduate, postgraduate, and research levels:
            </p>
            <ul class="list-disc text-gray-500 px-5">
                <li><span class="font-semibold">Disciplines:</span> Mathematics, Physics, Chemistry, Biotechnology,
                    Statistics, Computer Science
                </li>
                <li><span class="font-semibold">Labs & Facilities:</span> Fully equipped labs for Physics,
                    Bio-Chemistry, Molecular Biology, Organic/Inorganic Chemistry, and more
                </li>
                <li><span class="font-semibold">Focus Areas:</span> Pure and applied sciences, research, innovation,
                    patent development, and industry-aligned training
                </li>
            </ul>
            <p class="text-gray-500 text-justify my-2">Our curriculum is thoughtfully designed to balance academic rigor
                with industry relevance, preparing students for academic excellence and real-world success.
            </p>
        </div>

        <div id="courses" class="section px-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">ARNI offers academic programs that cater to students at graduate,
                post-graduate, and research levels, providing high-quality education and advanced interdisciplinary
                research. The department has well-equipped laboratories for various sciences, including Physics, MATLAB,
                Microbiology, Molecular Biology, Cell Culture, Virology, Bio-Chemistry, and Physical, Organic, and
                Inorganic chemistry, promoting a research culture.</p>
            <p class="text-gray-500 text-justify">These courses are curated to meet both academic rigor and the evolving
                needs of industry and research institutions. We offer a wide array of disciplines, including
                Mathematics, Chemistry, Physics, Statistics, Biotechnology, and Computer Science. Focuses on quality
                education, teamwork, partnerships, and innovation patenting, aiming to achieve a balance between pure
                basic, strategic basic, applied, and experimental development research.</p>
            <p class="text-gray-500 text-justify">These programs blend core science with emerging technologies to
                prepare students for academic excellence and real-world applications.
            </p>
            <!--<ul class="list-disc pl-5">
                <li class="text-gray-600 text-justify my-2">
                    Undergraduate Programs
                    <ul class="list-disc ml-6">
                        <li>B.Sc Medical</li>
                        <li>B.Sc Botany</li>
                        <li>B.Sc Microbiology</li>
                        <li>B.Sc Forensic Science</li>
                        <li>B.Sc Zoology</li>
                        <li>B.Sc Non Medical</li>
                    </ul>
                </li>
                <li class="text-gray-600 text-justify my-2">
                    Postgraduate Programs
                    <ul class="list-disc ml-6">
                        <li>M.Sc Zoology</li>
                        <li>M.Sc Botany</li>
                        <li>M.Sc Physics</li>
                        <li>M.Sc Chemistry</li>
                        <li>M.Sc Maths</li>
                    </ul>
                </li>
                <li class="text-gray-600 text-justify my-2">
                    Ph.D. Programs
                    <ul class="list-disc ml-6">
                        <li>Ph.D Botany</li>
                        <li>Ph.D Chemistry</li>
                        <li>Ph.D Maths</li>
                        <li>Ph.D Physics</li>
                    </ul>
                </li>
            </ul>-->
            <p class="text-gray-500 text-justify"><strong>Scope:</strong> The School of Basic Sciences & Biotechnology
                holds immense promise in molding the scientific minds of tomorrow. It offers a foundational
                understanding of fundamental scientific principles encompassing physics, chemistry, and biology, laying
                the groundwork for advanced research and innovation. Biotechnology, a burgeoning field at the
                intersection of biology and technology, finds ample scope here.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">Students will explore genetic engineering, bioinformatics,
                    and bioprocessing through interdisciplinary techniques; these fields have the potential to transform
                    environmental sustainability, healthcare, and agriculture.
                </li>
                <li class="text-gray-500 text-justify my-2">The school cultivates the practical skills, ethical
                    reasoning, and critical thinking necessary to tackle global issues.
                </li>
                <li class="text-gray-500 text-justify my-2">IStudents can become science writers, educators, or
                    consultants who translate complex research into digestible content for the public and policymakers.
                </li>
                <li class="text-gray-500 text-justify my-2">Biotechnology plays a major role in developing
                    pest-resistant crops, biofertilizers, and sustainable farming techniques, offering job roles in
                    agri-tech and environmental firms.
                </li>
                <li class="text-gray-500 text-justify my-2">Students can pursue research fellowships or higher studies
                    (M.Sc./Ph.D.) and contribute to scientific publications, patents, and innovative projects.
                </li>
                <li class="text-gray-500 text-justify my-2">With entrepreneurial skills, students can start ventures in
                    biotech diagnostics, environmental solutions, or organic farming.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">If you are passionate about science, innovations, and
                technologies and looking to kick-start your career in this field. Our course will guide you to your
                dream career. Join us now to be a part of this world of science and Technology.
            </p>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Research Scientist / Biotechnologist -</span>
                    Drive advancements in healthcare, agriculture, or environmental science.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Clinical Lab Technician / Analyst -</span>
                    Perform diagnostics in hospitals, labs, and research centers.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Pharmaceutical Associate -</span> Contribute
                    to drug development and clinical trials in the pharma sector.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Environmental Scientist -</span>
                    Work on sustainability projects and environmental impact analysis.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Academic Instructor / Professor -</span>
                    Educate and inspire the next generation of scientists and researchers.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">Students can also pursue research fellowships, Ph.D. programs,
                or launch startups in areas like diagnostics, organic farming, or green technologies.
            </p>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">We believe in experiential learning that combines lab-based projects,
                workshops, seminars, and field studies. Students engage in real-time problem-solving from microbiology
                to nanoscience, adhering to recognized global standards.
            </p>
            <p class="text-gray-500 my-2">Our faculty are scholars, researchers, and industry professionals who are not
                just teaching but mentoring students regarding research papers, internships, and employability. Students
                are encouraged to participate in science fairs, national conferences, and inter-university competitions
                that expand their intellectual boundaries. At ARNI, we take science beyond the curriculum and help shape
                tomorrow's scientists, innovators, and social change agents. Our alumni are producing research at
                exemplary institutions and working for reputable research centers and global biotech companies.
            </p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">Modern Labs & Equipment:</span> Cutting-edge
                    facilities for hands-on training in physics, chemistry, and biotechnology.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Expert Faculty & Mentorship:</span>
                    Experienced
                    professionals guide students through research, internships, and career planning.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Industry-Relevant Curriculum:</span> Courses
                    aligned with market needs, integrating life sciences, IT, and analytics.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Research-Centric Approach:</span> Emphasis on
                    innovation through project-based learning, publications, and scientific conferences.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Career Support & Placement:</span> Dedicated
                    career services for resume building, interview prep, and job placement.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Inclusive Education:</span> Scholarships,
                    flexible fees, and support for students from rural or underprivileged backgrounds.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">If you are passionate about science, innovations, and
                technologies, and are looking to kick-start your career in this field. Our course will guide you to your
                dream career. Join us now to be a part of this world of science and Technology.
            </p>
            <p class="mt-2 text-lg text-gray-500 font-semibold">Shape Your Future in Science</p>
            <p class="text-gray-500 mb-2">Whether your passion lies in research, innovation, or transforming communities
                through science—ARNI School of Basic Science & Biotechnology is the place to begin your journey.</p>
            <p class="my-2 text-gray-500 font-semibold">Join us today and be part of a future shaped by
                knowledge, innovation, and impact.</p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Basic Sciences & Biotechnology Disciplines &
                Specializations</h2>
            <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div
                    *ngFor="let department of departments"
                    class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                >
                    <div class="flex items-center mb-4">
                        <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                        <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                    </div>
                    <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                        <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                            <li *ngFor="let branch of department.branches">{{ branch }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="hoi-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img src="assets/img/hods-as-per-schools/neha-salaria.png"
                     alt="HOI Message"
                     class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Neha Salaria
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto custom-scrollbar">
                <h2 class="text-2xl font-bold mb-2">Head of Institute's Message</h2>
                <p class="text-gray-700 text-justify font-bold">
                    "In an era defined by transformation and limitless possibilities, ARNI University stands as a
                    catalyst for shaping futures with purpose, vision, and integrity."
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    As the Head of Institute, I take great pride in inviting you to a university that dares to go
                    beyond the conventional, I am privileged to oversee a vibrant academic community dedicated to
                    fostering intellectual curiosity, innovation, and personal growth. At ARNI, education is not
                    confined to classrooms—it is an evolving journey of curiosity, creativity, and courage. Our academic
                    ecosystem is designed to ignite minds, encourage innovation, and empower students to turn ideas into
                    action.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    At ARNI University, we offer a world-class, student-focused education designed for success in a
                    rapidly evolving world. With personalized advising, hands-on learning, and strong industry
                    partnerships, we equip students to turn ambitions into reality. Our inclusive environment values
                    every voice, fostering a vibrant, idea-driven community.
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    As you plan your future, we invite you to explore our diverse programs, connect with our admissions
                    team, and experience the spirit of ARNI. From your first inquiry to graduation and beyond, we blend
                    knowledge with values, global outlook with local relevance, and theory with real-world practice.
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    Our faculties are mentors, our classrooms are incubators of thought, and our campus is a space where
                    leadership, learning, and life converge is groomed. Here, you don’t just earn a degree—you discover
                    your purpose.
                </p>
                <p class="text-gray-700 mt-2 text-justify">Welcome to ARNI University. Let your journey begin-not just
                    to succeed, but to inspire.</p>
                <p class="text-gray-700 mt-2 text-justify">With best wishes,</p>
                <p class="text-gray-700 mt-2 text-justify font-bold">Dr. Neha Salaria</p>
                <p class="text-gray-700 mt-2 text-justify">Head of Institute</p>
                <p class="text-gray-700 mt-2 text-justify">ARNI School of Basic Science & Biotechnology</p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 object-fit rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>

                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

        <!--<div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;  <p class="font-bold text-[#012E26]">
                                                          Placed In:
                                                          <span class="text-[#00BFA5]">
                            {{ testimonial.company }}
                          </span>
                                                      </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>
